define((require) => {
    "use strict";

    const ProjectContentItemView  = require("ui/projects/content/ProjectContentItemView");
    const Tooltip                 = require("ui/common/Tooltip");
    const Promise                 = require("shared/util/Promise");
    const _                       = require("underscore");

    return ProjectContentItemView.extend({

        ui() {
            return _.defaults({
                detach: ".detach"
            }, ProjectContentItemView.prototype.ui);
        },

        events() {
            return _.defaults({
                "click @ui.detach": "_detachClickHandler"
            }, ProjectContentItemView.prototype.events);
        },

        onRender() {
            this.__super();

            Tooltip.add(this.ui.detach, {
                placement: "top",
                width: !this._spectatorMode ? 135 : 180
            });
        },

        _detachClickHandler() {
            Tooltip.remove(this.ui.detach);
            // Spectators don't have permissions to detach experiences.
            if (this._spectatorMode) {
                // TODO MOS-2643: Investigate if it's okay to use native promises here.
                return Promise.rejected();
            }

            const projectContext = this.options.projectContext;

            return projectContext.detach(this.model)
                .then(() => {
                    this.trigger("detach", this.model);
                    this.trigger("close");
                });
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/projects/content/ProjectDashboardContentItemView.js